import React from "react";
import { Modal, Button } from "rsuite";

const ConfirmDeleteModal = ({
  isOpen,
  title = "Delete item",
  message,
  onCancel,
  onConfirm,
  confirming = false,
}) => {
  return (
    <Modal open={isOpen} onClose={onCancel} backdrop={confirming ? "static" : true}>
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p style={{ margin: 0, fontSize: "0.95rem", color: "#4b5563", lineHeight: 1.5 }}>
          {message}
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={onCancel} appearance="subtle" disabled={confirming}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          appearance="primary"
          style={{ backgroundColor: "#dc2626", color: "white" }}
          disabled={confirming}
        >
          {confirming ? "Deleting…" : "Delete"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDeleteModal;


